// extracted by mini-css-extract-plugin
module.exports = {"TabContainer":"ExploreChip_TabContainer__Cl0HO","TabSubText":"ExploreChip_TabSubText__wsci5"};